import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Route guard: blocks direct URL access to modules the user lacks view permission on.
export const RequirePerm = ({ module, children }) => {
  const { user, loading, hasPermission } = useAuth();
  if (loading || !user) return children; // auth redirect is handled by Layout
  if (!hasPermission(module, 'view')) return <Navigate to="/dashboard" replace />;
  return children;
};

export default RequirePerm;
